module.exports = __webpack_public_path__ + "static/media/HomepageNoBottomLayers.1c1bd881.jpeg";